import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const MEETINGS_FILTERS_STORAGE_KEY = "latest-meetings-filters";

const _getDefaultMeetingsFilters = () => ({
  authors: [] as (string | number)[],
  animators: [] as (string | number)[],
  programs: [] as (string | number)[],
  meetingTypes: [] as (string | number)[],
  languages: [] as string[],
  startDate: computeDay() as string,
  endDate: computeDay(7) as string,
  showUnassigned: false,
  showDetailedSearch: false,
  search: "",
  activeCustomFilter: "",
});

export const getStoredMeetingsFilters = () => {
  const defaults = _getDefaultMeetingsFilters();

  try {
    const raw = localStorage.getItem(MEETINGS_FILTERS_STORAGE_KEY);
    if (!raw) return defaults;

    const parsed = JSON.parse(raw);
    return {
      authors: Array.isArray(parsed?.authors) ? parsed.authors : defaults.authors,
      animators: Array.isArray(parsed?.animators) ? parsed.animators : defaults.animators,
      programs: Array.isArray(parsed?.programs) ? parsed.programs : defaults.programs,
      meetingTypes: Array.isArray(parsed?.meetingTypes) ? parsed.meetingTypes : defaults.meetingTypes,
      languages: Array.isArray(parsed?.languages) ? parsed.languages : defaults.languages,
      startDate: defaults.startDate,
      endDate: defaults.endDate,
      showUnassigned: typeof parsed?.showUnassigned === "boolean" ? parsed.showUnassigned : defaults.showUnassigned,
      showDetailedSearch:
        typeof parsed?.showDetailedSearch === "boolean" ? parsed.showDetailedSearch : defaults.showDetailedSearch,
      search: typeof parsed?.search === "string" ? parsed.search : defaults.search,
      activeCustomFilter:
        typeof parsed?.activeCustomFilter === "string" ? parsed.activeCustomFilter : defaults.activeCustomFilter,
    };
  } catch {
    return defaults;
  }
};

export const computeDay = (days = 0): string => {
  const today = new Date();

  today.setDate(today.getDate() + days);
  return today.toISOString().split("T")[0];
};

export const fetchMeetingTypes = (setMeetingTypes: Function, setLoading: Function, language: string) => {
  ApiService.get("meetings/types?fetch_external=true")
    .then((response) => setMeetingTypes(response.data.meeting_types))
    .catch((err) => {
      console.error("Error fetching meeting types:", err);
      alert(translate(language, "PAGES.MEETINGS.ERROR.FETCH_MEETING_TYPES"));
    })
    .finally(() => setLoading((loading: any) => ({ ...loading, types: false })));
};

export const fetchResources = (
  setAuthors: Function,
  setAnimators: Function,
  setPrograms: Function,
  setLoading: Function,
  language: string
) => {
  ApiService.get("meetings/resources")
    .then((response) => {
      setAuthors(response.data.meeting_staff_and_programs.authors);
      setAnimators(response.data.meeting_staff_and_programs.animators);
      setPrograms(response.data.meeting_staff_and_programs.programs);
    })
    .catch((err) => {
      console.error("Error fetching meeting resources:", err.response || err);
      alert(translate(language, "PAGES.MEETINGS.ERROR.RESOURCES"));
    })
    .finally(() => setLoading((loading: any) => ({ ...loading, staff: false })));
};

export const downloadMeetingsCsv = (language: string, url: string, setDownloading: Function) => {
  setDownloading(true);

  ApiService.get(url)
    .then((resp) => {
      const link = document.createElement("a");
      const actualDate = new Date().toISOString().replace(/[:.]/g, "-").replace("T", "_").slice(0, 19);

      link.href = window.URL.createObjectURL(new Blob([resp.data]));
      link.setAttribute("download", `export-meetings-${actualDate}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((err) => {
      console.error(err);
      alert(translate(language, "PAGES.MEETINGS.ERROR.DOWNLOADING_CSV_ERROR"));
    })
    .finally(() => setDownloading(false));
};
